<template>
  <div></div>
</template>

<script>
import {
  Toast
} from 'vant'
import wx from 'weixin-js-sdk'
import {postAction} from '@/api/manage'

export default {
  name: 'ToPay',
  props: {},
  components: {
    [Toast.name]: Toast,
  },
  data() {
    return {
      orderInfo: {},
      ordersn: '',
    }
  },
  mounted() {
  },
  methods: {
    toShow(ordersn) {
      const that = this
      that.ordersn = ordersn
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      const payFormFlag = 1
      postAction('/web/api/order/getRechargeInfo', {
        'ordersn': that.ordersn
      }).then(function (res) {
        console.log(res.result)
        wx.chooseWXPay({
          timestamp: res.result.data.payInfo.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.result.data.payInfo.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.result.data.payInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: res.result.data.payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.result.data.payInfo.paySign, // 支付签名
          success: function (res) {
            console.log(res)
            // 支付成功后的回调函数
            that.$emit('ok')
            const toast = Toast.success({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              message: '支付成功',
            })
            let second = 3
            const timer = setInterval(() => {
              second--
              if (second) {
                toast.message = '支付成功'
              } else {
                clearInterval(timer)
                // 手动清除 Toast
                Toast.clear()
                that.$router.push({name: 'account/myOrderInfo', query: {ordersn: that.ordersn}})
              }
            }, 1000)
          },
          cancel: function(r) {
            that.$emit('can')
          },
          fail:function(r){
            //支付失败
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-toast__icon{
  font-size: 36px !important;
}
</style>
